export const environment = {
  name: 'production',
  signupUrl: 'https://signup.pay.nl',
  authUrl: 'https://auth.pay.nl',
  invalidSessionRedirectUrl: 'https://my.pay.nl',
  activation: {
    scope: 'gms',
    returnUrl: 'https://my.pay.nl/login/authentication/return',
    intendUrl: 'https://my.pay.nl/',
  },
  statusPageId: 'qvqb96s5y1zm',
};
